// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"crewNavigationBar_wrapper__ClmGZ","wrapper__center":"crewNavigationBar_wrapper__center__QM_9D","wrapper__menu":"crewNavigationBar_wrapper__menu__gJUz9"};